var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.58 9.462 5.162-5.163a1.778 1.778 0 0 1 2.516 0l5.33 5.33-6.529 6.31-6.48-6.478zm-.06 13.017 6.54-6.54 6.424 6.534-5.226 5.226a1.778 1.778 0 0 1-2.516 0l-5.221-5.22zm-6.478-3.965a3.557 3.557 0 0 1 0-5.03L13.485 3.042a3.557 3.557 0 0 1 5.03 0l10.443 10.443a3.557 3.557 0 0 1 0 5.03L18.515 28.958a3.557 3.557 0 0 1-5.03 0L3.042 18.515z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChess);
export default __webpack_public_path__ + "static/media/CHESS.852407924ecd12c269f7519406f9e3e2.svg";
export { ForwardRef as ReactComponent };